import { Box, Button, Grow, TextField, Typography } from "@mui/material";
import axios from "axios";
import { useState, useRef } from "react";
import Stepper from '@mui/joy/Stepper';
import Step from '@mui/joy/Step';
import StepIndicator from '@mui/joy/StepIndicator';
import PrimaryHeading from "../../Utilities/PrimaryHeading";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import toast from "react-hot-toast";
import PrimaryContent from "../../Utilities/PrimaryContent";
import CircularLoader from "../../Common/CircularLoader";
import { useSelector } from "react-redux";
import { CircularProgress } from '@mui/material';
import { ReportsHeader } from "../../Utilities/ReportsHeader";
import { NavButton, StyledBox } from "./RcAnalysis/WhyAnalysis";
import { FirstLetterCaps, rootColorFilter, sortFishboneKeys } from "../../../Helpers/NCRHelpers";
import { Stack } from "@mui/system";
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import { BsFillBookmarkCheckFill } from "react-icons/bs";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery'


const style = {
  content: {
    position: 'absolute', padding: '10px', width: '30%'
  },
  arrow: {
    // width: '40%', height: '1px', background: 'black', position: 'absolute', top: '60%', opacity: 0
  }
}

export default function ViewComponent() {
  const [ncrId, setNcrId] = useState("");
  const [ncrData, setNcrData] = useState(null);
  const accessToken = localStorage.getItem('NCProAccessToken');
  const [activeTab, setActiveTab] = useState(0);
  const [reportValue, setReportValue] = useState({
    pages: ["01", "02"],
    isFishBone: false,
    isWhyWhy: false
  });
  const [isLoading, setIsLoading] = useState(false);
  const [reportsFontSize, setReportsFontSize] = useState(11);
  const { userData } = useSelector((state) => state.user);
  const theme = useTheme();
  const isCustom = useMediaQuery('(min-width:1500px) and (max-width:1800px)')
  const isLaptop = useMediaQuery(theme.breakpoints.only('lg')) || isCustom
  const isCustom1 = useMediaQuery('(min-width:1200px) and (max-width:1350px)')
  const isTab = useMediaQuery(theme.breakpoints.down('lg')) || isCustom1

  const page1Ref = useRef(null);
  const page2Ref = useRef(null);
  const page3Ref = useRef(null);
  const page4Ref = useRef(null);

  const [evidenceAttachmentsImage, setEvidenceAttachmentsImage] = useState(null);
  const [correctiveActionImage, setCorrectiveActionImage] = useState(null);
  const [preventiveActionImage, setPreventiveActionImage] = useState(null);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  const handleStepClick = (index) => {
    setActiveTab(index);
  };

  const getImageUrl = (imageObject) => {
    if (!imageObject?.filename) return '/images/reports-page-sample-image.png';

    const filename = imageObject.filename.trim();
    const validExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
    const extension = filename.split('.').pop().toLowerCase();

    if (validExtensions.includes(extension)) {
      const BASE_URL = process.env.REACT_APP_BACKEND_APPLICATION_URL || "http://localhost:5000";
      return `${BASE_URL}/uploads/${filename}`;
    }

    return '/images/reports-page-sample-image.png';
  };

  const imageUrlToBase64 = async (imageObject) => {
    const imageUrl = getImageUrl(imageObject);
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
      });
    } catch (error) {
      console.error("Error converting image to Base64:", error);
      return null;
    }
  };

  const downloadPDF = async () => {
    setIsGeneratingPDF(true);
    try {
      const pdf = new jsPDF("l", "mm", "a4");
      const originalTab = activeTab;

      const capturePage = async (ref, tabIndex, addPage = false) => {
        setActiveTab(tabIndex);
        await new Promise((resolve) => setTimeout(resolve, 300));

        if (!ref.current) {
          console.log(`Missing ref for tab ${tabIndex}`);
          return;
        }

        const originalWidth = ref.current.style.width;
        const originalZoom = ref.current.style.zoom;

        ref.current.style.width = "1400px";
        ref.current.style.zoom = "1";

        const canvas = await html2canvas(ref.current, {
          scale: 2,
          useCORS: true,
        });

        ref.current.style.width = originalWidth;
        ref.current.style.zoom = originalZoom;

        const imgData = canvas.toDataURL("image/jpeg");

        const pageWidth = 297;
        const pageHeight = 210;
        const padding = 8;

        const borderX = padding;
        const borderY = padding;
        const borderWidth = pageWidth - padding * 2;
        const borderHeight = pageHeight - padding * 2;

        const imgWidth = borderWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        const finalImgHeight = (imgHeight > borderHeight ? borderHeight : imgHeight);
        const finalImgWidth = ((canvas.width * finalImgHeight) / canvas.height);

        console.log("finalImgHeight", finalImgWidth, finalImgHeight);

        const imgX = borderX + (borderWidth - finalImgWidth) / 2;
        const imgY = borderY + (borderHeight - finalImgHeight) / 2;

        if (addPage) pdf.addPage();

        pdf.addImage(imgData, "JPEG", imgX, imgY, finalImgWidth, finalImgHeight);
        pdf.setDrawColor(0);
        pdf.setLineWidth(0.3);
        pdf.rect(borderX, borderY, borderWidth, borderHeight);
      };

      await capturePage(page1Ref, 0);
      await capturePage(page2Ref, 1, true);

      if (reportValue?.isFishBone && reportValue?.isWhyWhy) {
        await capturePage(page3Ref, 2, true);
        await capturePage(page4Ref, 3, true);
      } else if (reportValue?.isFishBone && !reportValue?.isWhyWhy) {
        await capturePage(page3Ref, 2, true);
      } else if (!reportValue?.isFishBone && reportValue?.isWhyWhy) {
        await capturePage(page4Ref, !reportValue?.isFishBone ? 2 : 3, true);
      }

      setActiveTab(originalTab);
      pdf.save("NC_Report.pdf");
    } catch (error) {
      console.error("PDF Generation failed", error);
    } finally {
      setIsGeneratingPDF(false);
    }
  }

  const handleGenerateClick = async () => {
    try {
      setIsLoading(true);
      setNcrData(null);
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/ncr/forms/${ncrId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const { status } = response.data.ncrForm;
      if (status !== "In Closure" && status !== "Closed") {
        toast.error(`NC - ${ncrId} process is not completed`);
        return;
      }
      const form = response?.data?.ncrForm;
      setNcrData(form);
      setActiveTab(0);
      if (form) {

        const isFishboneHaveValue = Object.values(form?.fb_diagram || {})?.flat()?.some(item => Boolean(item?.data));
        const isWhyWhyHaveValue = Array.isArray(form?.why_why_analysis) && form.why_why_analysis.length > 0;
        const findReportValue = ((isFishboneHaveValue && form?.why_why_analysis) ? ["01", "02", "03", "04"] : (isFishboneHaveValue || form?.why_why_analysis) ? ["01", "02", "03"] : ["01", "02"]);

        setReportValue({
          pages: findReportValue || ["01", "02"],
          isFishBone: isFishboneHaveValue,
          isWhyWhy: isWhyWhyHaveValue
        });
        const { evidence_attachments, corrective_action_review_verification_evidence, preventive_action_review_verification_evidence } = response.data.ncrForm;
        const isValidImage = (img) => img && typeof img === 'object' && Object.keys(img).length > 0 && !!img.filename;

        const base64EvidenceAttachments = isValidImage(evidence_attachments)
          ? await imageUrlToBase64(evidence_attachments)
          : '/images/reports-page-sample-image.png';

        const base64CorrectiveAction = isValidImage(corrective_action_review_verification_evidence)
          ? await imageUrlToBase64(corrective_action_review_verification_evidence)
          : '/images/reports-page-sample-image.png';

        const base64PreventiveAction = isValidImage(preventive_action_review_verification_evidence)
          ? await imageUrlToBase64(preventive_action_review_verification_evidence)
          : '/images/reports-page-sample-image.png';

        setEvidenceAttachmentsImage(base64EvidenceAttachments);
        setCorrectiveActionImage(base64CorrectiveAction);
        setPreventiveActionImage(base64PreventiveAction);

        const fieldsToCheck = [
          'is_ncr_ready_for_closure',
          'comments_for_closure',
          'preventive_action_plan',
          'corrective_action_review_completed',
          'corrective_action_review_feedback',
          'corrective_actions_process_root_cause',
          'corrective_actions_ndrc',
          'corrective_actions_system_root_cause',
          'responsible_team_or_person',
          'what_went_wrong',
          'implement_interim_containment_action',
          'process_root_cause_identification',
          'ndrc_identification',
          'system_root_cause_identification'
        ];

        let maxLength = 0;
        fieldsToCheck.forEach((field) => {
          const value = form?.[field];
          if (typeof value === 'string') {
            maxLength = Math.max(maxLength, value.length);
          }
        });

        let fontSize = 11;
        if (maxLength > 200) {
          const reductionSteps = Math.floor((maxLength - 200) / 50) + 1;
          fontSize = Math.max(11 - reductionSteps, 7);
        }
        setReportsFontSize(fontSize);
      }

    } catch (error) {
      console.error('Error fetching ncr data:', error);
      toast.error(error.response?.data?.message || 'Something went wrong');
    } finally {
      await new Promise(resolve => setTimeout(resolve, 2500));
      setIsLoading(false);
    }
  }

  const renderFishBoneTextField = ({
    field,
    index,
  }) => {
    const item = ncrData?.fb_diagram?.[field.toLowerCase()]?.[index];
    const capsMatch = item?.data?.match(/[A-Z]/g);
    const hasMoreThanOneUppercase = capsMatch && capsMatch.length > 1;

    const inCaps = hasMoreThanOneUppercase ? 19 : 21;

    const displayValue = item?.data?.length > inCaps ? item.data.slice(0, inCaps) + "..." : item?.data || "";

    return <Box sx={{
      marginTop: "5px",
      color: (displayValue && !item?.is_highlighted) ? '#616a6b' : (displayValue && item?.is_highlighted) ? 'white' : "rgba(128, 128, 128, 1)",
      maxHeight: isTab ? '20px' : isLaptop ? '30px' : '45px',
      padding: isTab ? '5px' : '8px 14px',
      fontSize: (isTab && displayValue) ? '5.5px' : (isTab && !displayValue) ? '5px' : (isLaptop && displayValue) ? '8px' : (isLaptop && !displayValue) ? '9px' : displayValue ? '13px' : '14px',
      minWidth: '100%',
      width: isTab ? '72px' : isLaptop ? '120px' : "175px",
      border: (!displayValue && !item?.is_highlighted) && "1px solid rgba(128, 128, 128, 0.4)",
      borderRadius: isTab ? '3px' : isLaptop ? '4px' : "5px",
      display: "flex",
      alignItems: 'center',
      justifyContent: (displayValue && !item?.is_highlighted) ? "right" : displayValue ? "center" : 'center',
      backgroundColor: item?.is_highlighted ? rootColorFilter(field) : 'transparent',
      fontWeight: (displayValue) && 600,
    }}>
      {displayValue ? FirstLetterCaps(displayValue) : 'No data entered'}
    </Box>
  };

  const findWhyHeight = (char) => {
    return ncrData?.why_why_analysis?.some((item) => item?.content?.length > char)
  }

  return (
    <>
      <Box sx={{ pt: 8 }}>
        <Typography sx={{
          fontFamily: 'Lato',
          fontSize: '18px',
          fontWeight: 700,
          mb: 2,
          mt: 4
        }}>
          8D Report
        </Typography>
        <Box
          sx={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            backgroundColor: "#fff",
            marginTop: "16px",
            mb: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            py: 2,
            gap: 3
          }}
        >
          <Typography sx={{ fontWeight: '400', fontSize: '14px', color: 'rgba(0, 0, 0, 1)' }}>
            NC ID:
          </Typography>
          <TextField
            size='small'
            sx={{
              width: '190px',
            }}
            name="ncr_id"
            onChange={(e) => setNcrId(e.target.value)}
            value={ncrId}
            placeholder="Enter NC ID"
          />
          <Button
            variant="outlined"
            color="neutral"
            sx={{ background: 'linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)', textTransform: 'none', color: 'white', borderRadius: '10px', py: 1, textDecoration: '', fontWeight: 700, opacity: (!ncrId || isLoading || isGeneratingPDF) ? 0.7 : 1 }}
            onClick={() => !(!ncrId || isLoading || isGeneratingPDF) && handleGenerateClick()}
          >
            Generate report
          </Button>
        </Box>
        {(!isLoading && ncrData) &&
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <Button
              variant="outlined"
              color="neutral"
              sx={{ border: '1px solid rgba(14, 41, 102, 1)', textTransform: 'none', borderRadius: '10px', color: 'rgba(14, 41, 102, 1)', py: 1 }}
              onClick={downloadPDF}
            >
              Download
            </Button>
          </Box>
        }
      </Box>
      {isLoading
        ?
        <CircularLoader />
        :
        ncrData ?
          <Box sx={{ position: 'relative' }}>
            <Box
              sx={{
                border: '1px solid #ccc',
                borderRadius: '8px',
                backgroundColor: '#fff',
                marginTop: '16px',
                height: '65vh',
                overflow: 'hidden',
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  mx: 3,
                  my: 5
                }}
              >
                <Box sx={{ position: 'relative', transform: 'translateY(-17px)', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                  <Box sx={{ background: 'white', px: 2 }}>
                    <img
                      src="/images/reports-page-logo.svg"
                      alt="Banner"
                      style={{
                        width: 100,
                        mt: 1,
                        maxHeight: 100,
                      }}
                    />
                  </Box>
                  <Stepper sx={{ width: "20%" }}>
                    {reportValue?.pages?.map((label, index) => (
                      <Step
                        key={index}
                        sx={{ "--StepIndicator-size": "28px", cursor: "pointer" }}
                        onClick={() => handleStepClick(index)}
                        orientation="vertical"
                        indicator={
                          <StepIndicator
                            className="reprts-page-tabs"
                            sx={{
                              fontSize: '14px',
                              backgroundColor:
                                activeTab === index ? "rgba(14, 62, 186, 1)" : "rgba(255, 255, 255, 1)",
                              border: activeTab === index ? "none" : "1px solid gray",
                              color: activeTab === index ? 'rgba(255, 255, 255, 1)' : 'rgba(110, 110, 110, 1)',
                            }}
                            variant="solid"
                            color="neutral"
                          >
                            {label}
                          </StepIndicator>
                        }
                      />
                    ))}
                  </Stepper>
                  <Box sx={{ background: 'white', px: 2, }}>
                    <PrimaryHeading
                      sx={{
                        fontSize: '12px',
                        fontWeight: 500,
                        background: 'linear-gradient(90deg, #0D2663 0%, #43B0D7 100%)',
                        color: 'transparent',
                        backgroundClip: 'text',
                      }}
                    >
                      www.ncpro.gbinternational.sg
                    </PrimaryHeading>
                  </Box>
                </Box>
                <Box sx={{
                  height: "52vh",
                  overflowY: 'auto',
                  '&::-webkit-scrollbar': {
                    width: '7px',
                    height: '7px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(211, 211, 211, 1)',
                    borderRadius: '5px',
                  }
                }}>
                  {activeTab === 0 && (
                    <Grow
                      in={true}
                      style={{ transformOrigin: '0 0 0' }}
                      timeout={1000}
                    >
                      <Box ref={page1Ref} sx={{ p: 3 }}>
                        <Box>
                          <Typography className="reports-heading" sx={{ pb: 1, textAlign: 'center', width: '100%' }}>
                            8D REPORT
                          </Typography>
                        </Box>
                        <ReportsHeader ncrData={ncrData} userData={userData} />
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 3 }}>
                          <Box>
                            <Box sx={{ background: 'rgba(193, 39, 45, 1)', borderRadius: '4px', my: 1, py: '3px' }}>
                              <Typography className="default-text" sx={{ fontWeight: 800, color: 'rgba(255, 255, 255, 1)', textAlign: 'center' }}>Before</Typography>
                            </Box>
                            <Box
                              sx={{
                                width: '150px',
                                height: '90px',
                                border: '2px solid rgba(193, 39, 45, 1)',
                                borderRadius: '4px',
                                padding: (evidenceAttachmentsImage === '/images/reports-page-sample-image.png') ? "6px 34px" : "0px",
                                boxSizing: "border-box",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                src={evidenceAttachmentsImage}
                                alt="Banner"
                                style={{
                                  maxWidth: '100%',
                                  maxHeight: '100%',
                                  objectFit: 'contain',
                                  display: 'block',
                                }}
                              />
                            </Box>
                          </Box>
                          <Box>
                            <Box sx={{ background: 'rgba(21, 176, 87, 1)', borderRadius: '4px', my: 1, py: '3px' }}>
                              <Typography className="default-text" sx={{ fontWeight: 800, color: 'rgba(255, 255, 255, 1)', textAlign: 'center' }}>After</Typography>
                            </Box>
                            <Box sx={{ display: 'flex' }}>
                              <Box sx={{ pr: 2 }}>
                                <Box
                                  sx={{
                                    width: '150px',
                                    height: '90px',
                                    border: '2px solid rgba(21, 176, 87, 1)',
                                    borderRadius: '4px',
                                    padding: (correctiveActionImage === '/images/reports-page-sample-image.png') ? "6px 34px" : "0px",
                                    boxSizing: "border-box",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <img
                                    src={correctiveActionImage}
                                    alt="Banner"
                                    style={{
                                      maxWidth: '100%',
                                      maxHeight: '100%',
                                      objectFit: 'contain',
                                      display: 'block',
                                    }}
                                  />
                                </Box>
                              </Box>
                              <Box>
                                <Box
                                  sx={{
                                    width: '150px',
                                    height: '90px',
                                    border: '2px solid rgba(21, 176, 87, 1)',
                                    borderRadius: '4px',
                                    padding: (preventiveActionImage === '/images/reports-page-sample-image.png') ? "6px 34px" : "0px",
                                    boxSizing: "border-box",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <img
                                    src={preventiveActionImage}
                                    alt="Banner"
                                    style={{
                                      maxWidth: '100%',
                                      maxHeight: '100%',
                                      objectFit: 'contain',
                                      display: 'block',
                                    }}
                                  />
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                        <Box sx={{ pt: 8, height: '100%' }}>
                          <Box sx={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>
                            <Box sx={{ width: '30%', p: 2, display: 'flex', justifyContent: 'center', zIndex: '1' }}>
                              <img
                                src="/images/8d-reports/chart.png"
                                alt="Banner"
                                style={{ width: '100%', height: '100%', objectFit: 'contain', paddingTop: '30px', transform: 'scale(1.3)' }}
                              />
                            </Box>
                            <Box sx={[style?.content, { top: '-5%', right: '65%' }]}>
                              <Typography sx={{ fontSize: reportsFontSize, textAlign: 'end' }} className="reports-8d-explanation"><span style={{ color: 'rgba(87, 126, 243, 1)' }}>D8 - </span>Recognize the Team and Close the NCR</Typography>
                              <Typography className="reports-chart" sx={{ fontSize: reportsFontSize, textAlign: 'end' }}>{ncrData?.is_ncr_ready_for_closure || 'No Data Found'}</Typography>
                              <Typography className="reports-chart" sx={{ fontSize: reportsFontSize, textAlign: 'end' }}>{ncrData?.comments_for_closure || ''}</Typography>
                              <Box sx={[style?.arrow, { left: '99%', transform: 'rotate(20deg)', top: '60%', width: '43%' }]}></Box>
                            </Box>
                            <Box sx={[style?.content, { top: '30%', right: '70%' }]}>
                              <Typography sx={{ fontSize: reportsFontSize, textAlign: 'end' }} className="reports-8d-explanation"><span style={{ color: 'rgba(58, 150, 223, 1)' }}>D7 - </span>Prevent Recurrence</Typography>
                              <Typography className="reports-chart" sx={{ fontSize: reportsFontSize, textAlign: 'end' }}>{ncrData?.preventive_action_plan || 'No Data Found'}</Typography>
                              <Box sx={[style?.arrow, { right: '-30%', top: '50%', width: '30%' }]}></Box>
                            </Box>
                            <Box sx={[style?.content, { top: '60%', right: '70%' }]}>
                              <Typography sx={{ fontSize: reportsFontSize, textAlign: 'end' }} className="reports-8d-explanation"><span style={{ color: 'rgba(67, 195, 134, 1)' }}>D6 - </span>Implement and Validate Corrective Actions</Typography>
                              <Typography className="reports-chart" sx={{ fontSize: reportsFontSize, textAlign: 'end' }}>{ncrData?.corrective_action_review_completed || 'No Data Found'}</Typography>
                              <Typography className="reports-chart" sx={{ fontSize: reportsFontSize, textAlign: 'end' }}>{ncrData?.corrective_action_review_feedback || 'No Data Found'}</Typography>
                              <Box sx={[style?.arrow, { right: '-35%', top: '50%', width: '35%' }]}></Box>
                            </Box>
                            <Box sx={[style?.content, { top: '100%', right: '65%' }]}>
                              <Typography
                                sx={{ fontSize: reportsFontSize, textAlign: 'end' }}
                                className="reports-8d-explanation"
                              >
                                <span style={{ color: 'rgba(253, 203, 30, 1)' }}>D5 - </span>
                                Define Corrective Actions
                              </Typography>
                              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {[
                                  ncrData?.corrective_actions_process_root_cause || 'No Data Found',
                                  ncrData?.corrective_actions_ndrc || 'No Data Found',
                                  ncrData?.corrective_actions_system_root_cause || 'No Data Found',
                                ].map((text, index) => (
                                  <li
                                    key={index}
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'flex-end',
                                      marginBottom: '4px',
                                    }}
                                  >
                                    <Typography
                                      className="reports-chart"
                                      sx={{
                                        fontSize: reportsFontSize,
                                        textAlign: 'right',
                                        display: 'inline-block',
                                        pr: 1
                                      }}
                                    >
                                      {text}
                                    </Typography>
                                    <span
                                      style={{
                                        display: 'inline-block',
                                        width: '1em',
                                        textAlign: 'right',
                                        paddingRight: '0.4em',
                                        fontSize: "12px",
                                      }}
                                    >
                                      •
                                    </span>
                                  </li>
                                ))}
                              </ul>
                              <Box sx={[style?.arrow, { left: '99%', top: '12%', width: '36%', transform: 'rotate(160deg)' }]} />
                            </Box>

                            <Box sx={[style?.content, { top: '-5%', left: '65%' }]}>
                              <Typography sx={{ fontSize: reportsFontSize }} className="reports-8d-explanation"><span style={{ color: 'rgba(92, 92, 92, 1)' }}>D1 - </span>Establish the Team</Typography>
                              <Typography className="reports-chart" sx={{ fontSize: reportsFontSize }}>{ncrData?.responsible_team_or_person || 'No Data Found'}</Typography>
                              <Box sx={[style?.arrow, { right: '99%', transform: 'rotate(160deg)', top: '88%', width: '44%', }]}></Box>
                            </Box>
                            <Box sx={[style?.content, { top: '25%', left: '70%' }]}>
                              <Typography sx={{ fontSize: reportsFontSize }} className="reports-8d-explanation"><span style={{ color: 'rgba(127, 127, 127, 1)' }}>D2 - </span>Describe the Problem</Typography>
                              <Typography className="reports-chart" sx={{ fontSize: reportsFontSize }}>{ncrData?.what_went_wrong || 'No Data Found'}</Typography>
                              <Box sx={[style?.arrow, { right: '100%', top: '50%', width: '32%' }]}></Box>
                            </Box>
                            <Box sx={[style?.content, { top: '60%', left: '70%' }]}>
                              <Typography sx={{ fontSize: reportsFontSize }} className="reports-8d-explanation"><span style={{ color: 'rgba(223, 71, 84, 1)' }}>D3 - </span>Implement Interim Containment Actions</Typography>
                              <Typography className="reports-chart" sx={{ fontSize: reportsFontSize }}>{ncrData?.implement_interim_containment_action_other?.trim() || ncrData?.implement_interim_containment_action || 'No data found'}</Typography>
                              <Box sx={[style?.arrow, { right: '100%', top: '50%', width: '32%' }]}></Box>
                            </Box>
                            <Box sx={[style?.content, { top: '100%', left: '65%' }]}>
                              <Typography sx={{ fontSize: reportsFontSize }} className="reports-8d-explanation"><span style={{ color: 'rgba(207, 101, 21, 1)' }}>D4 - </span>Identify Root Causes</Typography>
                              <ul style={{ paddingLeft: '1.2em', margin: 0 }}>
                                <li>
                                  <Typography className="reports-chart" sx={{ fontSize: reportsFontSize }}>
                                    {ncrData?.process_root_cause_identification_other?.trim() || ncrData?.process_root_cause_identification || 'No data found'}
                                  </Typography>
                                </li>
                                <li>
                                  <Typography className="reports-chart" sx={{ fontSize: reportsFontSize }}>
                                    {ncrData?.ndrc_identification_other?.trim() || ncrData?.ndrc_identification || 'No data found'}
                                  </Typography>
                                </li>
                                <li>
                                  <Typography className="reports-chart" sx={{ fontSize: reportsFontSize }}>
                                    {ncrData?.system_root_cause_identification_other?.trim() || ncrData?.system_root_cause_identification || 'No data found'}
                                  </Typography>
                                </li>
                              </ul>
                              <Box sx={[style?.arrow, { right: '99%', top: '25%', width: '38%', transform: 'rotate(20deg)' }]}></Box>
                            </Box>
                          </Box>
                        </Box>
                        <Box sx={{ pt: 20 }}>
                          <PrimaryHeading
                            sx={{
                              fontSize: '12px',
                              textAlign: 'end',
                              fontWeight: 500,
                              color: 'rgb(42, 61, 189)',
                            }}
                          >
                            www.ncpro.gbinternational.sg
                          </PrimaryHeading>
                        </Box>
                      </Box>
                    </Grow>
                  )}
                  {activeTab === 1 && (
                    <Grow
                      in={true}
                      style={{ transformOrigin: '0 0 0' }}
                      timeout={1000}
                    >
                      <Box ref={page2Ref} sx={{ p: 3 }}>
                        <Box>
                          <Typography className="reports-heading" sx={{ pb: 1, textAlign: 'center', width: '100%' }}>
                            8D REPORT
                          </Typography>
                        </Box>
                        <ReportsHeader ncrData={ncrData} userData={userData} />
                        <Box sx={{ display: 'flex', pt: 2, justifyContent: 'space-between', alignItems: 'flex-end' }}>
                          <Box sx={{ width: '100%' }}>
                            <Box sx={{ py: 1 }}>
                              <Typography className="default-text" sx={{ fontSize: '20px', fontWeight: 600, color: 'rgba(31, 31, 31, 1)', textAlign: 'start' }}>{ncrData?.what_went_wrong || 'No data found'}</Typography>
                            </Box>
                            <Box sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', background: 'rgba(87, 126, 243, 1)', py: 1, px: 1 }}>
                                <img
                                  src="/images/8d-reports/d1-icon.svg"
                                  alt="Banner"
                                  style={{
                                    maxHeight: 100,
                                  }}
                                />
                                <Typography className="reports-box-heading" sx={{ pl: 1 }}>D1 Responsible Team/ Person</Typography>
                              </Box>
                              <Box sx={{ px: 1 }}>
                                <ul style={{ paddingLeft: '10px' }} >
                                  <Typography className="default-text" sx={{ fontSize: '12px', fontWeight: 500, }}>
                                    {ncrData?.responsible_team_or_person || 'No data found'}
                                  </Typography>
                                </ul>
                              </Box>
                            </Box>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', }}>
                            <Box sx={{ px: 4 }}>
                              <Box sx={{ background: 'rgba(193, 39, 45, 1)', borderRadius: '4px', my: 1, py: '3px' }}>
                                <Typography className="default-text" sx={{ fontWeight: 800, color: 'rgba(255, 255, 255, 1)', textAlign: 'center' }}>Before</Typography>
                              </Box>
                              <Box
                                sx={{
                                  width: '150px',
                                  height: '90px',
                                  border: '2px solid rgba(193, 39, 45, 1)',
                                  borderRadius: '4px',
                                  padding: (evidenceAttachmentsImage === '/images/reports-page-sample-image.png') ? "6px 34px" : "0px",
                                  boxSizing: "border-box",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  src={evidenceAttachmentsImage}
                                  alt="Banner"
                                  style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    objectFit: 'contain',
                                    display: 'block',
                                  }}
                                />
                              </Box>
                            </Box>
                            <Box>
                              <Box sx={{ background: 'rgba(21, 176, 87, 1)', borderRadius: '4px', my: 1, py: '3px' }}>
                                <Typography className="default-text" sx={{ fontWeight: 800, color: 'rgba(255, 255, 255, 1)', textAlign: 'center' }}>After</Typography>
                              </Box>
                              <Box sx={{ display: 'flex' }}>
                                <Box sx={{ pr: 2 }}>
                                  <Box
                                    sx={{
                                      width: '150px',
                                      height: '90px',
                                      border: '2px solid rgba(21, 176, 87, 1)',
                                      borderRadius: '4px',
                                      padding: (correctiveActionImage === '/images/reports-page-sample-image.png') ? "6px 34px" : "0px",
                                      boxSizing: "border-box",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <img
                                      src={correctiveActionImage}
                                      alt="Banner"
                                      style={{
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        objectFit: 'contain',
                                        display: 'block',
                                      }}
                                    />
                                  </Box>
                                </Box>
                                <Box>
                                  <Box
                                    sx={{
                                      width: '150px',
                                      height: '90px',
                                      border: '2px solid rgba(21, 176, 87, 1)',
                                      borderRadius: '4px',
                                      padding: (preventiveActionImage === '/images/reports-page-sample-image.png') ? "6px 34px" : "0px",
                                      boxSizing: "border-box",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <img
                                      src={preventiveActionImage}
                                      alt="Banner"
                                      style={{
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        objectFit: 'contain',
                                        display: 'block',
                                      }}
                                    />
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', minHeight: '80px', alignItems: 'stretch' }}>
                          <Box
                            sx={{
                              background: 'rgba(58, 150, 223, 1)',
                              width: '120px',
                              minWidth: '120px',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                            }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
                              <img src="/images/8d-reports/d2-icon.svg" alt="Banner" style={{ maxHeight: 100 }} />
                              <Typography className="reports-box-heading" sx={{ px: 1 }}>D2</Typography>
                            </Box>
                            <Typography className="reports-box-heading" sx={{ textAlign: 'center' }}>Problem?</Typography>
                          </Box>
                          <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', border: '1px solid rgba(224, 224, 224, 1)', ml: 1 }}>
                            <ul style={{ paddingLeft: '10px' }} >
                              <Typography className="default-text" sx={{ fontSize: '12px', fontWeight: 500, }}>
                                {ncrData?.what_went_wrong || 'No data found'}
                              </Typography>
                            </ul>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', minHeight: '80px', alignItems: 'stretch' }}>
                          <Box
                            sx={{
                              background: 'rgba(65, 189, 130, 1)',
                              width: '120px',
                              minWidth: '120px',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                            }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                              <img src="/images/8d-reports/d3-icon.svg" alt="Banner" style={{ maxHeight: 100 }} />
                              <Typography className="reports-box-heading" sx={{ px: 1 }}>D3</Typography>
                            </Box>
                            <Typography className="reports-box-heading" sx={{ textAlign: 'center' }}>Containment Action</Typography>
                          </Box>
                          <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', border: '1px solid rgba(224, 224, 224, 1)', ml: 1 }}>
                            <ul style={{ paddingLeft: '10px' }} >
                              <Typography className="default-text" sx={{ fontSize: '12px', fontWeight: 500, }}>
                                {ncrData?.implement_interim_containment_action_other?.trim() || ncrData?.implement_interim_containment_action || 'No data found'}
                              </Typography>
                            </ul>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', minHeight: '100px', alignItems: 'stretch' }}>
                          <Box
                            sx={{
                              background: 'rgba(253, 203, 30, 1)',
                              width: '120px',
                              minWidth: '120px',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                            }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
                              <img src="/images/8d-reports/d4-icon.svg" alt="Banner" style={{ maxHeight: 100 }} />
                              <Typography className="reports-box-heading" sx={{ px: 1 }}>D4</Typography>
                            </Box>
                            <Typography className="reports-box-heading" sx={{ textAlign: 'center' }}>PRC Identification</Typography>
                          </Box>
                          <Box sx={{ width: '100%', display: 'flex', alignItems: 'stretch', border: '1px solid rgba(224, 224, 224, 1)', ml: 1 }}>
                            <Box sx={{ width: '33%', display: 'flex', alignItems: 'center' }}>
                              <ul style={{ paddingLeft: '10px' }}>
                                <Typography className="default-text" sx={{ fontSize: '12px', fontWeight: 500 }}>
                                  {ncrData?.process_root_cause_identification_other?.trim() || ncrData?.process_root_cause_identification || 'No data found'}
                                </Typography>
                              </ul>
                            </Box>
                            <Box
                              sx={{
                                background: 'rgba(253, 203, 30, 1)',
                                width: '120px',
                                minWidth: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                              }}
                            >
                              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
                                <img src="/images/8d-reports/d4-icon.svg" alt="Banner" style={{ maxHeight: 100 }} />
                                <Typography className="reports-box-heading" sx={{ px: 1 }}>D4</Typography>
                              </Box>
                              <Typography className="reports-box-heading" sx={{ textAlign: 'center' }}>NDRC Identification</Typography>
                            </Box>
                            <Box sx={{ width: '33%', display: 'flex', alignItems: 'center' }}>
                              <ul style={{ paddingLeft: '10px' }}>
                                <Typography className="default-text" sx={{ fontSize: '12px', fontWeight: 500 }}>
                                  {ncrData?.ndrc_identification_other?.trim() || ncrData?.ndrc_identification || 'No data found'}
                                </Typography>
                              </ul>
                            </Box>
                            <Box
                              sx={{
                                background: 'rgba(253, 203, 30, 1)',
                                width: '120px',
                                minWidth: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                              }}
                            >
                              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
                                <img src="/images/8d-reports/d4-icon.svg" alt="Banner" style={{ maxHeight: 100 }} />
                                <Typography className="reports-box-heading" sx={{ px: 1 }}>D4</Typography>
                              </Box>
                              <Typography className="reports-box-heading" sx={{ textAlign: 'center' }}>SRC Identification</Typography>
                            </Box>
                            <Box sx={{ width: '33%', display: 'flex', alignItems: 'center' }}>
                              <ul style={{ paddingLeft: '10px' }}>
                                <Typography className="default-text" sx={{ fontSize: '12px', fontWeight: 500 }}>
                                  {ncrData?.system_root_cause_identification_other?.trim() || ncrData?.system_root_cause_identification || 'No data found'}
                                </Typography>
                              </ul>
                            </Box>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', minHeight: '100px', alignItems: 'stretch' }}>
                          <Box
                            sx={{
                              background: 'rgba(236, 119, 24, 1)',
                              width: '120px',
                              minWidth: '120px',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                            }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
                              <img src="/images/8d-reports/d5-icon.svg" alt="Banner" style={{ maxHeight: 100 }} />
                              <Typography className="reports-box-heading" sx={{ px: 1 }}>D5</Typography>
                            </Box>
                            <Typography className="reports-box-heading" sx={{ textAlign: 'center' }}>CA for PRC</Typography>
                          </Box>
                          <Box sx={{ width: '100%', display: 'flex', alignItems: 'stretch', border: '1px solid rgba(224, 224, 224, 1)', ml: 1 }}>
                            <Box sx={{ width: '33%', display: 'flex', alignItems: 'center' }}>
                              <ul style={{ paddingLeft: '10px' }}>
                                <Typography className="default-text" sx={{ fontSize: '12px', fontWeight: 500 }}>
                                  {ncrData?.corrective_actions_process_root_cause || 'No data found'}
                                </Typography>
                              </ul>
                            </Box>
                            <Box
                              sx={{
                                background: 'rgba(236, 119, 24, 1)',
                                width: '120px',
                                minWidth: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                              }}
                            >
                              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
                                <img src="/images/8d-reports/d5-icon.svg" alt="Banner" style={{ maxHeight: 100 }} />
                                <Typography className="reports-box-heading" sx={{ px: 1 }}>D5</Typography>
                              </Box>
                              <Typography className="reports-box-heading" sx={{ textAlign: 'center' }}>CA for NDRC</Typography>
                            </Box>
                            <Box sx={{ width: '33%', display: 'flex', alignItems: 'center' }}>
                              <ul style={{ paddingLeft: '10px' }}>
                                <Typography className="default-text" sx={{ fontSize: '12px', fontWeight: 500 }}>
                                  {ncrData?.corrective_actions_ndrc || 'No data found'}
                                </Typography>
                              </ul>
                            </Box>
                            <Box
                              sx={{
                                background: 'rgba(236, 119, 24, 1)',
                                width: '120px',
                                minWidth: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                              }}
                            >
                              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
                                <img src="/images/8d-reports/d5-icon.svg" alt="Banner" style={{ maxHeight: 100 }} />
                                <Typography className="reports-box-heading" sx={{ px: 1 }}>D5</Typography>
                              </Box>
                              <Typography className="reports-box-heading" sx={{ textAlign: 'center' }}>CA for SRC</Typography>
                            </Box>
                            <Box sx={{ width: '33%', display: 'flex', alignItems: 'center' }}>
                              <ul style={{ paddingLeft: '10px' }}>
                                <Typography className="default-text" sx={{ fontSize: '12px', fontWeight: 500 }}>
                                  {ncrData?.corrective_actions_system_root_cause || 'No data found'}
                                </Typography>
                              </ul>
                            </Box>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', minHeight: '80px', alignItems: 'stretch' }}>
                          <Box
                            sx={{
                              background: 'rgba(190, 61, 76, 1)',
                              width: '120px',
                              minWidth: '120px',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                            }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
                              <img src="/images/8d-reports/d6-icon.svg" alt="Banner" style={{ maxHeight: 100 }} />
                              <Typography className="reports-box-heading" sx={{ px: 1 }}>D6</Typography>
                            </Box>
                            <Typography className="reports-box-heading" sx={{ textAlign: 'center' }}>CA completed?</Typography>
                          </Box>
                          <Box sx={{ width: '100%', display: 'flex', alignItems: 'stretch', border: '1px solid rgba(224, 224, 224, 1)', ml: 1 }}>
                            <Box sx={{ width: 'calc(33% - 76px)', display: 'flex', alignItems: 'center' }}>
                              <ul style={{ paddingLeft: '10px' }}>
                                <Typography className="default-text" sx={{ fontSize: '12px', fontWeight: 500 }}>
                                  {ncrData?.corrective_action_review_completed || 'No data found'}
                                </Typography>
                              </ul>
                            </Box>
                            <Box
                              sx={{
                                background: 'rgba(190, 61, 76, 1)',
                                width: '120px',
                                minWidth: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                              }}
                            >
                              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
                                <img src="/images/8d-reports/d6-icon.svg" alt="Banner" style={{ maxHeight: 100 }} />
                                <Typography className="reports-box-heading" sx={{ px: 1 }}>D6</Typography>
                              </Box>
                              <Typography className="reports-box-heading" sx={{ textAlign: 'center' }}>CA Review</Typography>
                            </Box>
                            <Box sx={{ width: '60%' }}>
                              <ul style={{ paddingLeft: '10px' }}>
                                <Typography className="default-text" sx={{ fontSize: '12px', fontWeight: 500 }}>
                                  {ncrData?.corrective_action_review_feedback || 'No data found'}
                                </Typography>
                              </ul>
                            </Box>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', minHeight: '120px', alignItems: 'stretch' }}>
                          <Box
                            sx={{
                              background: 'rgba(127, 127, 127, 0.85)',
                              width: '120px',
                              minWidth: '120px',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                            }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
                              <img src="/images/8d-reports/d7-icon.svg" alt="Banner" style={{ maxHeight: 100 }} />
                              <Typography className="reports-box-heading" sx={{ px: 1 }}>D7</Typography>
                            </Box>
                            <Typography className="reports-box-heading" sx={{ textAlign: 'center' }}>PA Plan</Typography>
                          </Box>
                          <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', border: '1px solid rgba(224, 224, 224, 1)', ml: 1 }}>
                            <ul style={{ paddingLeft: '10px' }} >
                              <Typography className="default-text" sx={{ fontSize: '12px', fontWeight: 500, }}>
                                {ncrData?.preventive_action_plan || 'No data found'}
                              </Typography>
                            </ul>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', minHeight: '80px', alignItems: 'stretch' }}>
                          <Box
                            sx={{
                              background: 'rgba(91, 91, 91, 1)',
                              width: '120px',
                              minWidth: '120px',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                            }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
                              <img src="/images/8d-reports/d8-icon.svg" alt="Banner" style={{ maxHeight: 100 }} />
                              <Typography className="reports-box-heading" sx={{ px: 1 }}>D8</Typography>
                            </Box>
                            <Typography className="reports-box-heading" sx={{ textAlign: 'center' }}>Closure?</Typography>
                          </Box>
                          <Box sx={{ width: '100%', display: 'flex', alignItems: 'stretch', border: '1px solid rgba(224, 224, 224, 1)', ml: 1 }}>
                            <Box sx={{ width: 'calc(33% - 76px)', display: 'flex', alignItems: 'center' }}>
                              <ul style={{ paddingLeft: '10px' }}>
                                <Typography className="default-text" sx={{ fontSize: '12px', fontWeight: 500 }}>
                                  {ncrData?.is_ncr_ready_for_closure || 'No data found'}
                                </Typography>
                              </ul>
                            </Box>
                            <Box
                              sx={{
                                background: 'rgba(91, 91, 91, 1)',
                                width: '120px',
                                minWidth: '120px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                              }}
                            >
                              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
                                <img src="/images/8d-reports/d8-icon.svg" alt="Banner" style={{ maxHeight: 100 }} />
                                <Typography className="reports-box-heading" sx={{ px: 1 }}>D8</Typography>
                              </Box>
                              <Typography className="reports-box-heading" sx={{ textAlign: 'center' }}>Closure?</Typography>
                            </Box>
                            <Box sx={{ width: '60%' }}>
                              <ul style={{ paddingLeft: '10px' }}>
                                <Typography className="default-text" sx={{ fontSize: '12px', fontWeight: 500 }}>
                                  {ncrData?.comments_for_closure || 'No data found'}
                                </Typography>
                              </ul>
                            </Box>
                          </Box>
                        </Box>
                        <Box sx={{ pt: 2 }}>
                          <PrimaryHeading
                            sx={{
                              fontSize: '12px',
                              textAlign: 'end',
                              fontWeight: 500,
                              color: 'rgb(42, 61, 189)',
                            }}
                          >
                            www.ncpro.gbinternational.sg
                          </PrimaryHeading>
                        </Box>
                      </Box>
                    </Grow>
                  )}
                  {activeTab === (reportValue?.isFishBone && 2) && (
                    <Grow
                      in={true}
                      style={{ transformOrigin: '0 0 0' }}
                      timeout={1000}
                    >
                      <Box ref={page3Ref} sx={{ p: 3 }}>
                        <Box>
                          <Typography className="reports-heading" sx={{ textAlign: 'center', width: '100%' }}>
                            8D REPORT - ROOT CAUSE ANALYSIS
                          </Typography>
                        </Box>
                        <ReportsHeader ncrData={ncrData} userData={userData} />
                        <Box sx={{ width: "100%", padding: "20px 0" }}>
                          <Typography sx={{ fontSize: "20px", margin: '0 auto', fontWeight: 600 }}>
                            FISH-BONE DIAGRAM
                          </Typography>
                          <div style={{ position: 'relative', margin: '0 auto', zIndex: 0 }}>
                            <img
                              src="/images/fish.png"
                              style={{ width: '100%', height: 'auto', display: 'block' }}
                              alt="fish"
                            />

                            <div>
                              <Typography style={{ fontFamily: 'Lato, sans-serif', position: 'absolute', top: '12%', left: '18%', transform: 'translate(-50%, -50%)', fontWeight: 600, color: '#fff', fontSize: isTab ? '8px' : isLaptop && '12.5px' }}>MANPOWER</Typography>

                              <div style={{ position: 'absolute', top: '23%', left: '17.5%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'MANPOWER', index: 0, color: '#FCB433' })}
                              </div>

                              <div style={{ position: 'absolute', top: '31%', left: '21.5%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'MANPOWER', index: 1, color: '#FCB433' })}
                              </div>

                              <div style={{ position: 'absolute', top: '38.5%', left: '25.2%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'MANPOWER', index: 2, color: '#FCB433' })}
                              </div>

                            </div>

                            <div>
                              <Typography style={{ fontFamily: 'Lato, sans-serif', position: 'absolute', top: '12%', left: '34%', transform: 'translate(-50%, -50%)', fontWeight: 600, color: '#fff', fontSize: isTab ? '8px' : isLaptop && '12.5px' }}>METHOD</Typography>

                              <div style={{ position: 'absolute', top: '23%', left: '33.8%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'METHOD', index: 0, color: '#F14B62' })}
                              </div>

                              <div style={{ position: 'absolute', top: '31%', left: '37.7%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'METHOD', index: 1, color: '#F14B62' })}
                              </div>

                              <div style={{ position: 'absolute', top: '38%', left: '41.3%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'METHOD', index: 2, color: '#F14B62' })}
                              </div>

                            </div>

                            <div>
                              <Typography style={{ fontFamily: 'Lato, sans-serif', position: 'absolute', top: '12%', left: '50%', transform: 'translate(-50%, -50%)', fontWeight: 600, color: '#fff', fontSize: isTab ? '8px' : isLaptop && '12.5px' }}>MACHINE</Typography>

                              <div style={{ position: 'absolute', top: '23%', left: '49.8%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'MACHINE', index: 0, color: '#BC3743' })}
                              </div>

                              <div style={{ position: 'absolute', top: '31%', left: '53.7%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'MACHINE', index: 1, color: '#BC3743' })}
                              </div>

                              <div style={{ position: 'absolute', top: '38.5%', left: '57.3%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'MACHINE', index: 2, color: '#BC3743' })}
                              </div>

                            </div>

                            <div>
                              <Typography style={{ fontFamily: 'Lato, sans-serif', position: 'absolute', bottom: '11%', left: '50%', transform: 'translate(-50%, -50%)', fontWeight: 600, color: '#fff', fontSize: isTab ? '8px' : isLaptop && '12.5px' }}>MEASUREMENT</Typography>
                              <div style={{ position: 'absolute', top: '59%', left: '57.5%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px", color: 'black' }}>
                                {renderFishBoneTextField({ field: 'MEASUREMENT', index: 0, color: '#66C068' })}
                              </div>

                              <div style={{ position: 'absolute', top: '66.8%', left: '53.7%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'MEASUREMENT', index: 1, color: '#66C168' })}
                              </div>

                              <div style={{ position: 'absolute', top: '74%', left: '49.8%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'MEASUREMENT', index: 2, color: '#66C268' })}
                              </div>

                            </div>

                            <div>
                              <Typography style={{ fontFamily: 'Lato, sans-serif', position: 'absolute', bottom: '11%', left: '34%', transform: 'translate(-50%, -50%)', fontWeight: 600, color: '#fff', fontSize: isTab ? '8px' : isLaptop && '12.5px' }}>ENVIRONMENT</Typography>
                              <div style={{ position: 'absolute', top: '59%', left: '41.5%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px", color: 'black' }}>
                                {renderFishBoneTextField({ field: 'ENVIRONMENT', index: 0, color: '#3DC1F2' })}
                              </div>

                              <div style={{ position: 'absolute', top: '67%', left: '37.8%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'ENVIRONMENT', index: 1, color: '#3DC1F2' })}
                              </div>

                              <div style={{ position: 'absolute', top: '74%', left: '34%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'ENVIRONMENT', index: 2, color: '#3DC1F2' })}
                              </div>

                            </div>

                            <div>
                              <Typography style={{ fontFamily: 'Lato, sans-serif', position: 'absolute', bottom: '11%', left: '18%', transform: 'translate(-50%, -50%)', fontWeight: 600, color: '#fff', fontSize: isTab ? '8px' : isLaptop && '12.5px' }}>MATERIAL</Typography>
                              <div style={{ position: 'absolute', top: '59%', left: '25.5%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px", color: 'black' }}>
                                {renderFishBoneTextField({ field: 'MATERIAL', index: 0, color: '#A66DF5' })}
                              </div>

                              <div style={{ position: 'absolute', top: '66.5%', left: '21.7%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'MATERIAL', index: 1, color: '#A66DF5' })}
                              </div>

                              <div style={{ position: 'absolute', top: '74%', left: '18%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                                {renderFishBoneTextField({ field: 'MATERIAL', index: 2, color: '#A66DF5' })}
                              </div>

                            </div>

                            <Box style={{ position: 'absolute', top: '50%', right: isLaptop ? '4%' : '2.5%', transform: 'translate(-50%, -50%)', padding: '0 2px', width: isTab ? '90px' : isLaptop ? '130px' : "200px", height: isTab ? '35px' : isLaptop ? '60px' : "80px", borderRadius: "5px", backgroundColor: "#F14B62", display: 'flex', justifyContent: "center", alignItems: "center" }}>
                              <div style={{ position: "relative" }}>
                                <Button sx={{
                                  fontFamily: 'Lato, sans-serif',
                                  cursor: "pointer", color: "#fff", fontWeight: 600, fontSize: isTab ? '10px' : isLaptop ? '15px' : "25px"
                                }}>
                                  PROBLEM
                                </Button>
                              </div>

                            </Box>
                            <div style={{
                              position: 'absolute', top: '75%', right: isTab ? '-20%' : isLaptop ? '-13%' : '-7.5%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "10px",
                              width: isTab ? '230px' : isLaptop ? '300px' : "350px",
                              height: 'auto',
                              boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.1)",
                            }}
                            >
                              <Typography sx={{
                                fontFamily: 'Lato, sans-serif',
                                p: 2,
                                backgroundColor: "#f2f3f4",
                                height: '48px',
                                fontSize: isTab ? '13px' : isLaptop ? '16px' : ''
                              }}>
                                What went wrong ?
                              </Typography>
                              <Typography sx={{
                                fontFamily: 'Lato, sans-serif',
                                p: 2,
                                backgroundColor: "white",
                                fontSize: isTab ? '11px' : isLaptop ? '15px' : ''
                              }}>
                                {FirstLetterCaps(ncrData?.what_went_wrong + '.') || '-'}
                              </Typography>
                            </div>
                          </div>
                          {Object.entries(ncrData?.fb_diagram)?.flatMap(([category, items]) => items?.filter(item => item.is_highlighted))?.length > 0 && <Typography sx={{ fontSize: "20px", margin: '0 auto' }}>
                            Highlighted Sub-cause
                          </Typography>}
                          <div style={{ width: "100%", display: "flex", alignContent: "center", gap: "10px", flexWrap: "wrap", marginTop: "15px" }}>
                            {Object.entries(sortFishboneKeys(ncrData?.fb_diagram))?.flatMap(([category, items]) =>
                              items?.filter(item => item.is_highlighted)?.map(item => {
                                const enrichedItem = { ...item, rootName: category };
                                return (
                                  <div key={`${category}-${item.id}`} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    <img
                                      src={`/images/${category} Star.png`}
                                      alt={`${category} star`}
                                      style={{
                                        width: '35px',
                                        height: "30px",
                                      }}
                                    />
                                    {enrichedItem?.data}
                                  </div>
                                );
                              })
                            )}
                          </div>
                        </Box>
                        <Box>
                          <PrimaryHeading
                            sx={{
                              fontSize: '12px',
                              textAlign: 'end',
                              fontWeight: 500,
                              color: 'rgb(42, 61, 189)',
                            }}
                          >
                            www.ncpro.gbinternational.sg
                          </PrimaryHeading>
                        </Box>
                      </Box>
                    </Grow>
                  )}
                  {activeTab === (!reportValue?.isFishBone ? 2 : 3) && (
                    <Grow
                      in={true}
                      style={{ transformOrigin: '0 0 0' }}
                      timeout={1000}
                    >
                      <Box ref={page4Ref} sx={{ p: 5 }}>
                        <Box>
                          <Typography className="reports-heading" sx={{ fontFamily: 'Lato, sans-serif', pb: 1, textAlign: 'center', width: '100%' }}>
                            8D REPORT - ROOT CAUSE ANALYSIS
                          </Typography>
                        </Box>
                        <ReportsHeader ncrData={ncrData} userData={userData} />
                        <Box sx={{ mt: 5, mb: findWhyHeight(200) ? 5 : findWhyHeight(100) ? 20 : 25 }}>
                          <Box sx={{ width: "100%", padding: "10px 0" }}>
                            <Typography sx={{ fontFamily: 'Lato, sans-serif', fontSize: "20px", margin: '0 auto', fontWeight: 600 }}>
                              WHY WHY ANALYSIS
                            </Typography>
                            <Box sx={{ padding: 4, margin: 'auto', width: "100%" }}>
                              <Stack direction={{ xs: "column", md: "row" }} rowGap={5} alignItems="flex-start" style={{ marginTop: "40px" }}>
                                {ncrData?.why_why_analysis?.map((item, index) => {
                                  const textFiledStyles = item?.is_submitted ? {
                                    minHeight: "100px",
                                    backgroundColor: "#c0392b",
                                    color: "white",
                                    display: "flex",
                                    alignItems: "start",
                                    flexWrap: "wrap",
                                    borderRadius: "8px",
                                  } : {}

                                  return (
                                    <div key={item?.id} style={{ width: '300px' }}>
                                      <div style={{ width: "100%" }}>
                                        <div style={{
                                          width: '100%',
                                          display: 'flex',
                                          justifyContent: "start",
                                          alignItems: "center",
                                        }}>
                                          <div style={{
                                            border: '3px solid rgba(128, 128, 128, 0.2)',
                                            width: '65%',
                                            display: 'flex',
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "10%",
                                            padding: '8px 10px 8px 5px'
                                          }}>
                                            <StyledBox bgcolor={item?.color} idx={index} style={{ width: "100%" }}>
                                              <Typography variant="h6" fontWeight="bold" sx={{ fontFamily: 'Lato, sans-serif', }}>
                                                {item?.title}
                                              </Typography>
                                            </StyledBox>
                                          </div>
                                          {index < ncrData?.why_why_analysis?.length - 1 && (
                                            <div style={{
                                              width: '35%',
                                              paddingLeft: "5px",
                                              height: "3px",
                                              backgroundColor: "#e5e7e9",
                                              position: "relative"
                                            }}>
                                              <div style={{ position: "absolute", transform: 'translate(-50%,-50%)', left: "50%", top: "5px" }}>
                                                <MdOutlineArrowForwardIos style={{ fontSize: 32, color: item?.color, marginLeft: "12px", fontWeight: 900 }} />
                                              </div>
                                            </div>
                                          )}
                                        </div>

                                        <div style={{
                                          width: '60%',
                                          display: 'flex',
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          gap: "10px",
                                          marginTop: '10px',
                                          marginLeft: "2px"
                                        }}>
                                          {index !== 4 && (
                                            <NavButton
                                              title="Next"
                                              icon={<SkipNextIcon style={{ fontSize: "25px" }} />}
                                              disabled={!item?.content || (5 !== index)}
                                            />
                                          )}

                                          {index !== 0 && (
                                            <NavButton
                                              title="Previous"
                                              icon={<SkipPreviousIcon style={{ fontSize: "25px" }} />}
                                              disabled={(5 !== index)}
                                            />
                                          )}


                                          {index === 0 &&
                                            <NavButton
                                              title="Submit"
                                              icon={<BsFillBookmarkCheckFill style={{ fontSize: "22px" }} />}
                                              disabled={!item?.content}
                                            />
                                          }

                                          {index !== 0 &&
                                            <NavButton
                                              title="Submit"
                                              icon={<BsFillBookmarkCheckFill style={{ fontSize: "22px" }} />}
                                              disabled={!item?.content}
                                            />
                                          }
                                        </div>

                                        <div style={{
                                          width: "63%",
                                          marginTop: "10px",
                                          minHeight: '40px',
                                          borderRadius: "5px",
                                          display: "flex",
                                          alignItems: "center"
                                        }}>
                                          <div style={{
                                            width: "100%",
                                            minHeight: "100px",
                                            backgroundColor: "rgba(128, 128, 128, 0.2)",
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            flexWrap: "wrap",
                                            borderRadius: "8px",
                                            padding: "10px",
                                            ...textFiledStyles
                                          }}>
                                            <Typography style={{
                                              fontFamily: 'Lato, sans-serif',
                                              width: "100%",
                                              wordBreak: "break-word",
                                              whiteSpace: "normal",
                                              fontSize: "15px",
                                            }}>
                                              {item?.content}
                                            </Typography>
                                          </div>
                                        </div>
                                        {item?.is_submitted && <Typography sx={{
                                          fontFamily: 'Lato, sans-serif',
                                          width: "100%",
                                          wordBreak: "break-word",
                                          whiteSpace: "normal",
                                          fontSize: "15px",
                                          marginTop: "10px",
                                          fontWeight: 400,
                                          ml: 1
                                        }}>
                                          FINAL ROOT CAUSE
                                        </Typography>
                                        }
                                      </div>
                                    </div>
                                  )
                                })}
                              </Stack>
                            </Box>
                          </Box>
                        </Box>
                        <Box>
                          <PrimaryHeading
                            sx={{
                              fontSize: '12px',
                              textAlign: 'end',
                              fontWeight: 500,
                              color: 'rgb(42, 61, 189)',
                            }}
                          >
                            www.ncpro.gbinternational.sg
                          </PrimaryHeading>
                        </Box>
                      </Box>
                    </Grow>
                  )}
                </Box>
              </Box>
            </Box>
            {isGeneratingPDF && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: '100%',
                  width: '100%',
                  zIndex: 1000,
                  backgroundColor: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '8px',
                }}
              >
                <CircularProgress />
              </Box>
            )}
          </Box>
          :
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              height: '600px',
              textAlign: 'center',
            }}
          >
            <PrimaryContent sx={{ my: 2 }}>The generated 8D report will be shown here</PrimaryContent>
          </div>
      }
    </>
  )
}